import CourseNameStep from './CourseNameStep';
import UnitsStep from './UnitsStep';
import SubunitsStep from './SubunitsStep';
import CourseImageStep from './CourseImageStep';
import ReviewStep from './ReviewStep';
import StepsIndicator from './StepsIndicator';

export { CourseNameStep, UnitsStep, SubunitsStep, CourseImageStep, ReviewStep, StepsIndicator };
